import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import PutHooks from "../../../Api/PutHook";
import AlertComponent from "../../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const TransactionWithdrawApprovalForm = ({
  user,
  data,
  onClose,
  fetchData,
}) => {
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [approval, setApproval] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [approvalLoading, approvalResponse, approvalRequest] = PutHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const requestApproval = async () => {
    let formData = {
      request_id: data?.id,
      transaction_id: data?.transaction_id,
      status: approval,
    };

    const resp = await approvalRequest({
      url: "request_transaction",
      body: formData,
    });

    if (resp && resp.status === 200 && resp.data.StatusCode === 0) {
      setSnackbar({
        open: true,
        message: resp.data.StatusMessage,
        severity: "success",
      });
      onClose();
      fetchData();
    } else {
      const errorMessage =
        resp?.data?.StatusMessage ??
        resp?.data?.message ??
        resp.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(requestApproval)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          my: "20px",
        }}
      >
        <InputLabel id="status">Status</InputLabel>
        <Select
          labelId="status"
          id="status"
          defaultValue=""
          value={approval}
          label="Status"
          onChange={(e) => setApproval(e.target.value)}
          required
        >
          <MenuItem value="ACCEPTED">Accept </MenuItem>
          <MenuItem value="DECLINED">Decline </MenuItem>
        </Select>
      </FormControl>

      <Box
        sx={{
          pt: "40px",
          gap: 2,
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          loading={approvalLoading}
        >
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default TransactionWithdrawApprovalForm;
